import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { ref, onMounted } from "vue";
import UButton from "@/components/UButton.vue";
import { Message } from "@/interfaces/message";
import { updateMessage } from "@/helpers/requestHelpers/ordersRequests";
import { Conversation } from "@/interfaces/conversation";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import { useNotificationStore } from "@/store/notificationStore";
import QrScanner from "./QrScanner.vue";
import { patientString } from "@/helpers/patienthelper";
import { useSessionStore } from "@/store/sessionStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderMessageMedicationBoxScanner',
  props: {
    messages: {},
    conversation: {},
    boxes: {}
  },
  setup(__props: any) {

const props = __props;

let scanMedicationResults = ref<Array<Message>>([]);

const notificationStore = useNotificationStore();

let lastScannedCode = "";
let selectedBox: undefined | Message = undefined;

onMounted(() => {
  window._paq.push([
    "trackEvent",
    "BoxScanner",
    "opened Boxscanner",
    undefined,
  ]);
});

async function scannedQr(result: string, status: number): Promise<null> {
  window._paq.push([
    "trackEvent",
    "BoxScanner",
    "scanned something",
    undefined,
  ]);

  if (result.includes("-")) {
    if (result == lastScannedCode) return null;
    let splittedText = result.split("-");
    if (splittedText.length != 3) {
      console.error("invalid box qr code #1");
      return null;
    }
    if (splittedText[0] != "umanabox") {
      console.error("invalid box qr code #2");
      return null;
    }
    let conversationId = parseInt(splittedText[1]);
    let boxId = parseInt(splittedText[2]);
    selectedBox = props.boxes.find((box) => boxId == box.id);

    notificationStore.removeNotificationsWithId("scanner");

    if (conversationId != selectedBox?.conversation.id) {
      notificationStore.notifications.push({
        msg: `Diese Kiste wurde nicht in dieser Bestellung gefunden! Kiste nicht ausgewählt.`,
        type: "danger",
        customId: "scanner",
      });
      return null;
    }

    notificationStore.notifications.push({
      msg: `Kiste "${selectedBox?.medication_box?.name ?? "unb."}" ausgewählt.`,
      type: "success",
      customId: "scanner",
    });
  } else {
    if (!selectedBox?.medication_box) {
      notificationStore.removeNotificationsWithId("scanner");
      notificationStore.notifications.push({
        msg: `keine Kiste ausgewählt.`,
        type: "danger",
        customId: "scanner",
      });
      return null;
    }
    scanMedicationResults.value = [];
    let results = 0;
    for (const msg of props.messages) {
      if (
        msg.medication_order &&
        msg.medication_order.gtin == parseInt(result) &&
        !msg.medication_order.deleted
      ) {
        if (!msg.medication_order?.box) {
          scanMedicationResults.value.push(msg);
        }
        results++;
      }
    }
    if (scanMedicationResults.value.length == 0) {
      notificationStore.removeNotificationsWithId("scanner");
      if (results == 0) {
        notificationStore.notifications.push({
          msg: `Medikament wurde nicht in der Bestellung gefunden.`,
          type: "danger",
          customId: "scanner",
        });
      } else {
        notificationStore.notifications.push({
          msg: `Diese Produkte wurden bereits einer Kiste zugeordnet.`,
          type: "danger",
          customId: "scanner",
        });
      }

      return null;
    }
  }

  lastScannedCode = result;

  return null;
}

async function medicationToBox(medication: Message) {
  await updateMessage(
    props.conversation,
    medication,
    new Map([
      [
        "status",
        useSessionStore().selectedCareProviderGroup
          ?.medication_status_after_scan,
      ],
      ["box", selectedBox?.id],
    ])
  );
  scanMedicationResults.value = [];
  notificationStore.removeNotificationsWithId("scanner");
  notificationStore.notifications.push({
    msg: `${medication.medication_order?.amount}x ${
      medication.medication_order?.name
    } für ${patientString(medication.medication_order?.patient_id ?? 0)}
     der Kiste "${
       selectedBox?.medication_box?.name ?? "unb."
     }" zugeordnet und Status angepasst`,
    type: "success",
    customId: "scanner",
  });
}

return (_ctx: any,_cache: any) => {
  return ((_unref(scanMedicationResults)?.length ?? 0) == 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(QrScanner, {
          onQrScanned: scannedQr,
          "request-status": false
        }),
        _createVNode(UButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.$emit('close');
        _isRef(scanMedicationResults) //@ts-ignore
 ? scanMedicationResults.value = [] : scanMedicationResults = [];
      })
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Kamera Beenden ")
          ]),
          _: 1
        })
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(UmanaHeadline, { h: "h3" }, {
          default: _withCtx(() => [
            _createTextVNode("Welche Bestellung soll in die Kiste verschoben werden?")
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(scanMedicationResults), (scanMedicationResult) => {
          return (_openBlock(), _createBlock(UButton, {
            key: scanMedicationResult.id,
            color: "white",
            class: "my-s w-full",
            onClick: ($event: any) => (medicationToBox(scanMedicationResult))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scanMedicationResult.medication_order?.amount) + "x " + _toDisplayString(scanMedicationResult.medication_order?.name) + " (" + _toDisplayString(_unref(patientString)(scanMedicationResult.medication_order?.patient_id ?? 0)) + ") ", 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128)),
        _createVNode(UButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(scanMedicationResults) //@ts-ignore
 ? scanMedicationResults.value = [] : scanMedicationResults = [])),
          color: "red",
          class: "mt-s w-full"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Abbrechen ")
          ]),
          _: 1
        })
      ]))
}
}

})